import { scrollbarStyle } from '@common/utils-scrollbar';
import styled from '@emotion/styled';
import { Theme } from '@gemini/fe-ds-core';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

export const BookingDetailsContainer = styled('div')<{
  isFullRecap?: boolean;
  borderColor?: string;
}>(props => ({
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${props.borderColor || '#d9e4f5'}`,
  borderRadius: '0.5rem',
  height: props.isFullRecap ? 'fit-content' : '100%',
  maxHeight: props.isFullRecap ? 'none' : '100%',
  minHeight: 0,
  maxWidth: '100%',
  overflow: 'hidden',

  '@media screen and (max-width: 576px)': {
    position: 'relative',
  },
  position: 'relative',
}));

export const BookingCard = styled.div<{ theme: Theme; noPadding?: boolean }>(
  ({ theme, noPadding }) => ({
    borderRadius: '0 0 0.5rem 0.5rem',
    borderTop: 'none',
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: '100%',
    overflowY: 'auto',
    margin: '0.5rem',

    ...scrollbarStyle(theme, {
      width: '0.25rem',
      borderRadius: '1.5rem',
    }),

    padding: noPadding ? '0.5rem 0' : '0 1rem',
  }),
);

export const CardTitleWrapper = styled.div<{
  borderColor?: string;
  padding?: string;
  flexColumnInMobile?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${props => props.borderColor || '#d9e4f5'};
  border-radius: 0.5rem 0.5rem 0 0;
  padding: ${props => props.padding || '1rem'};
  height: 3.5rem;
  background-color: #fff;

  @media screen and (max-width: ${MobileBreakpoint}px) {
    height: fit-content;
    flex-direction: ${props =>
      props.flexColumnInMobile === false ? 'row' : 'column'};
    align-items: ${props =>
      props.flexColumnInMobile === false ? 'center' : 'flex-start'};
  }
`;

export const DetailSection = styled.div<{
  isLast?: boolean;
  gap?: string;
  borderColor?: string;
}>(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem 0',
  },
  ({ isLast, gap, borderColor }) => ({
    borderBottom: !isLast ? `1px solid ${borderColor || '#D9E4F5'}` : '0',
    gap: gap,
  }),
);

export const PatientPill = styled.div<{
  customTextColor?: string;
  customBorderColor?: string;
  customColor: string;
}>(
  {
    display: 'flex',
    height: '2rem',
    padding: '0.25rem 0.5rem',
    alignItems: 'center',
    gap: '0.5rem',
    borderRadius: '0.5rem',
    width: 'fit-content',
  },
  ({ customTextColor, customColor, customBorderColor }) => ({
    backgroundColor: customColor,
    border: `1px solid ${customBorderColor || 'transparent'}`,
    color: customTextColor || 'black',
  }),
);

export const ColumnWrapper = styled.div<{ gap?: string; isRow?: boolean }>(
  {
    display: 'flex',
    alignItems: 'start',
    gap: '0.5rem',
    overflow: 'hidden',
  },
  ({ gap }) => ({
    gap: gap,
  }),
  ({ isRow }) => ({
    flexDirection: isRow ? 'row' : 'column',
    width: isRow ? '100%' : 'unset',
  }),
);

export const InsuranceContainer = styled.div<{ isRow?: boolean }>`
  @media (min-width: 576px) {
    display: flex;
    ${props => !props.isRow && 'width: 100%'}
    gap: 2.5rem;
  }
  row-gap: 0.5rem;
  display: grid;
`;

export const InsuranceColumn = styled.div`
  @media (min-width: 576px) {
    display: flex;
    flex-direction: column;
    // width: calc((100% - 40px) / 2);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  row-gap: 0.5rem;
  display: grid;
`;

export const AddressSection = styled.div<{ isFullRecap?: boolean }>`
  display: flex;
  ${props =>
    props.isFullRecap
      ? 'align-items: flex-end; justify-content: space-between;'
      : 'flex-direction: column;'}
  @media screen and (max-width: ${MobileBreakpoint}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ButtonLabelWrapper = styled.div`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
`;

export const AddressCtasWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 0.5rem;
`;

export const InsPtCtDetailsWrapper = styled.div<{ halfWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: ${props => props.halfWidth && '50%'};
  @media screen and (max-width: ${MobileBreakpoint}px) {
    width: 100%;
  }
`;

export const ScheduleDetailsWrapper = styled.div<{
  typ?: boolean;
  flexRow?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 1rem;
  /* @media screen and (max-width: 1024px) { */
  flex-direction: ${props => (props.typ || props.flexRow ? 'row' : 'column')};
  align-items: flex-start;
  gap: ${props => (props.typ ? '2.5rem' : '0.5rem')};
  /* } */
  @media screen and (max-width: ${MobileBreakpoint}px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ScheduleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SubSectionTitle = styled.div<{ gap?: string }>(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  ({ gap }) => ({
    gap: gap,
  }),
);

export const ItemWrapper = styled.div<{
  direction?: 'horizontal' | 'vertical';
  align?: string;
}>({ display: 'flex', gap: '0.5rem' }, ({ direction, align }) => ({
  maxWidth: ' 100%',
  overflow: 'hidden',
  flexDirection: direction === 'vertical' ? 'column' : 'row',
  alignItems: align,
}));

export const PtDetailsWrapper = styled.div<{ halfWidth?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 0.5rem;
  width: ${props => props.halfWidth && '50%'};

  @media screen and (max-width: ${MobileBreakpoint}px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonWrapper = styled.div`
  @media print {
    display: none;
  }
`;
